import React from "react";
import { Field, useFormikContext } from "formik";
import StarIcon from "../../assets/icons/req-star";
import UploadIcon from "../../assets/icons/upload-icon";
import { useDispatch } from "react-redux";
import { imageUploadAction } from "../../redux/actions/general-action";
import { toImageUrl } from "../../utils/image-url";
import ErrorMsg from "./error-msg";

const MultipleImagesField = ({
  isRequired = false,
  labelClass = "whitespace-nowrap flex text-sm fw_400 text-secondary",
  labelWidth = "12.8rem",
  setloading,
  isDisabled = false,
  // Defaults keep the original Shop Images behaviour; pass `name` to use this
  // for any other multi-image field.
  name = "shop_images",
  label = "Add Images",
}) => {
  const { setFieldValue, values, errors } = useFormikContext();
  const current = Array.isArray(values?.[name]) ? values[name] : [];
  const dispatch = useDispatch();
  const handleFileChange = (event) => {
    setloading(true);
    const files = event.target.files;
    for (let index = 0; index < files?.length; index++) {
      dispatch(imageUploadAction(files?.[index], onSuccess, onError));
    }
  };
  const onSuccess = (data) => {
    setloading(false);
    setFieldValue(name, [...current, toImageUrl(data)]);
  };
  const onError = () => {
    setFieldValue(name, current);
    setloading(false);
  };
  
  return (
    <div>
      <label
        htmlFor={name}
        className={`flex items-center ${labelClass} w-full`}
      >
        <span
          style={{
            minWidth: labelWidth,
          }}
          className="flex text-label-color"
        >
          {label}
          {isRequired && (
            <span className="ml-2">
              <StarIcon />
            </span>
          )}
        </span>{" "}
        <div
          style={{
            height: "2.9rem",
          }}
          className={`${
            errors[name]
              ? ` inputField_border__error`
              : ` inputField_border`
          }   flex items-center gap-3 w-full py-10 text-667085`}
        >
          <UploadIcon fill="var(--placeholder-color)" />
          Upload File
        </div>
      </label>

      <Field>
        {({ field, form }) => (
          <input
            disabled={isDisabled}
            multiple
            id={name}
            type="file"
            accept=".png, .jpg, .jpeg"
            onChange={(event) => {
              handleFileChange(event);
              // No field.onChange here. Formik resolves a field from the target's
              // name/id, so letting it run set this field to the input's own value
              // — the "C:\fakepath\..." string — replacing the array of uploaded
              // URLs. The value is owned by the upload callback above.
            }}
            onBlur={field.onBlur}
            style={{ display: "none" }}
          />
        )}
      </Field>
      <ErrorMsg name={name} />
    </div>
  );
};

export default MultipleImagesField;
